module.exports = __webpack_public_path__ + "img/level-of-difficulty-arrow-down.8ad5ecb0.svg";